import React from 'react'
import './headerbackground.css'

export default function HeaderBackground() {
  return (
    <div className='backgroundFirst' style={{ backgroundColor: `var(--bg-color)`, color: `var(--text-color)` }}>
      
    </div>
  )
}
